import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    Stack,
    Fade,
    Box,
    IconButton
} from "@mui/material";
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { SelectProvincailCouncilInMandate } from "../../Include/DynamicSelect"

export default function ProvincailCouncilItem({ elem, index, setProvincailCouncilList, viewOnly }) {

    // Function to remove an item from the list
    const handleRemoveItem = (index) => {
        setProvincailCouncilList((prev) => {
        
            return prev.filter((_, i) => i !== index)
        });
    };

    const handleUpdateItemList = (index, value, field) => {
        setProvincailCouncilList((prev) =>
            prev.map((obj, i) => {
                if (i !== index) return obj;
                return { ...obj, [field]: value };
            })
        );
    };

    return (
        <Fade in key={index}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <SelectProvincailCouncilInMandate  
                        valueSelected={elem?.provincialCouncilInMandateId}
                        required={true}   
                        onChange={(val) =>
                            handleUpdateItemList(
                                index,
                                val || { id: "", title: "" },
                                "provincialCouncilInMandateId"
                            )
                        }
                    />
                </Grid>
                <Grid item xs={4.8}>
                    <FormControl fullWidth className="search-field" size="small">
                        <Select
                            value={elem?.roleInWorkGroup}
                            onChange={(e) => handleUpdateItemList(
                                index,
                                e?.target?.value || 'member',
                                "roleInWorkGroup"
                            )}
                        >
                            <MenuItem value={"president"}>President</MenuItem>
                            <MenuItem value={"vice_president"}>Vice President</MenuItem>
                            <MenuItem value={"member"}>Member</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={1.2}>
                    {/* <Stack justifyContent={"center"} alignItems={"center"}> */}
                        <IconButton onClick={() => handleRemoveItem(index)} disabled={viewOnly}>
                            <IndeterminateCheckBoxIcon
                                onClick={() => handleRemoveItem(index)}
                                fontSize="medium"
                                sx={{ color: viewOnly ? "gray" : "red", cursor: "pointer" }}
                            />
                        </IconButton>
                    {/* </Stack> */}
                </Grid>
            </Grid>
        </Fade>
    )
}